var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General / Edit 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3369 3.62981C14.5075 2.45736 16.4063 2.45664 17.5779 3.62821L20.0697 6.12006C21.2313 7.28164 21.2434 9.16211 20.0968 10.3385L10.8637 19.8118C10.1111 20.5839 9.07893 21.0193 8.00114 21.0192L5.24899 21.0191C3.82761 21.0191 2.69248 19.8342 2.75226 18.413L2.87041 15.604C2.91254 14.6023 3.32884 13.653 4.03693 12.9438L13.3369 3.62981ZM16.1648 5.04349C15.7742 4.65297 15.1413 4.65321 14.7511 5.04403L13.2646 6.53272L17.1887 10.4568L18.6656 8.9415C19.0478 8.54936 19.0438 7.92254 18.6566 7.53535L16.1648 5.04349ZM5.45115 14.3581L11.8515 7.94801L15.7927 11.8892L9.43249 18.4148C9.05621 18.8008 8.54012 19.0185 8.00122 19.0185L5.24908 19.0184C4.9648 19.0184 4.73778 18.7814 4.74973 18.4971L4.86789 15.6881C4.88895 15.1873 5.0971 14.7126 5.45115 14.3581ZM20.5147 20.9459C21.0668 20.9459 21.5143 20.4981 21.5143 19.9456C21.5143 19.3931 21.0668 18.9452 20.5147 18.9452H14.393C13.8409 18.9452 13.3934 19.3931 13.3934 19.9456C13.3934 20.4981 13.8409 20.9459 14.393 20.9459H20.5147Z",
    fill: "#726C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.3dbb04b1c3dcdea4f9e5f28a7c398d67.svg";
export { ForwardRef as ReactComponent };